(function () {
  'use strict';

  // Nur einmal pro Seitenaufruf ausführen
  if (window.__deinsparGeoMarketRunning) return;
  window.__deinsparGeoMarketRunning = true;

  // Nicht im Shopify Theme Editor ausführen
  if (window.Shopify && Shopify.designMode) return;

  const hostname = window.location.hostname
    .toLowerCase()
    .replace(/^www\./, '');

  // WICHTIG:
  // Geo-Erkennung nur auf der Hauptdomain deinspar.com
  if (hostname !== 'deinspar.com') return;

  // Nur wenn der Kunde wirklich deinspar.com/ aufruft.
  // /de-de, Produkte, Collections, Country Selector usw.
  // werden NICHT angefasst.
  if (window.location.pathname !== '/') return;

  async function detectCountry() {
    try {
      const url = new URL(
        '/browsing_context_suggestions.json',
        window.location.origin
      );

      url.searchParams.set('country[enabled]', 'true');

      const response = await fetch(url.toString(), {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const data = await response.json();

      const suggestion = Array.isArray(data.suggestions)
        ? data.suggestions.find(function (item) {
            return (
              item &&
              item.parts &&
              item.parts.country &&
              item.parts.country.handle
            );
          })
        : null;

      if (!suggestion) return;

      const detectedCountry =
        suggestion.parts.country.handle.toUpperCase();

      const currentCountry =
        window.Shopify && Shopify.country
          ? Shopify.country.toUpperCase()
          : '';

      // Shopify befindet sich bereits im richtigen Land.
      if (detectedCountry === currentCountry) return;

      updateCountry(detectedCountry);
    } catch (error) {
      // Bei einem Fehler nichts tun.
      // Der Shop funktioniert dann ganz normal weiter.
    }
  }

  function updateCountry(countryCode) {
    const form = document.createElement('form');

    form.method = 'POST';
    form.action = '/localization';
    form.hidden = true;

    const methodInput = document.createElement('input');
    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = 'PUT';

    const countryInput = document.createElement('input');
    countryInput.type = 'hidden';
    countryInput.name = 'country_code';
    countryInput.value = countryCode;

    const returnInput = document.createElement('input');
    returnInput.type = 'hidden';
    returnInput.name = 'return_to';
    returnInput.value = '/';

    form.appendChild(methodInput);
    form.appendChild(countryInput);
    form.appendChild(returnInput);

    document.body.appendChild(form);

    form.submit();
  }

  detectCountry();
})();